import authService from "@services/auth";

export default [
  {
    path: "/",
    name: "home",
    component: () => lazyLoadView(import("@views/Home"))
  },
  {
    path: "/Login",
    name: "login",
    component: () => import("@views/Login"),
    meta: {
      beforeResolve(to, from, next) {
        var authenticated = authService.isAuthenticated();

        // refreshtoken
        if (authenticated === false) {
          const isAuthenticated = () => {
            authService
              .refreshToken()
              .then(() => authService.isAuthenticated());
          };
          authenticated = isAuthenticated();
        }

        if (authenticated === true) {
          next({ name: "home" });
        } else {
          next();
        }
      }
    }
  },
  {
    path: "/CadastrarSenha",
    name: "cadastrar-senha",
    component: () => import("@views/CadastrarSenha")
  },
  {
    path: "/EsqueceuSenha",
    name: "esqueceu-senha",
    component: () => import("@views/EsqueceuSenha")
  },
  {
    path: "/Logout",
    name: "logout",
    meta: {
      beforeResolve() {
        authService.logout();
      }
    }
  },
  {
    path: "/Calendario",
    name: "calendario",
    component: () => lazyLoadView(import("@views/Calendario"))
  },
  {
    path: "/Atendimentos",
    name: "atendimentos",
    component: () => lazyLoadView(import("@views/Atendimentos"))
  },
  {
    path: "/Cadastros",
    name: "cadastros",
    component: () => lazyLoadView(import("@views/Cadastros")),
    meta: {
      requiredRoles() {
        return ["Administrador"];
      }
    }
  },
  {
    path: "/Chamado",
    name: "chamado",
    props: {
      name: "Chamados",
      table: "Chamado",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/Chamado"))
  },
  {
    path: "/Chamado/Detalhes/:id",
    name: "Chamados",
    props: {
      name: "Chamados",
      table: "Chamado",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/ChamadoDetalhe"))
  },
  {
    path: "/Feriado",
    name: "feriado",
    props: {
      name: "Feriado",
      table: "Feriado",
      fields: [
        { name: "descricao", description: "Descrição" },
        { name: "tipo", description: "Tipo" },
        { name: "data", description: "Data", type: "date" },
        { name: "recorrente", description: "Recorrente", type: "boolean" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Feriado/Detalhes/:id",
    name: "feriado-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/FeriadoForm"))
  },
  {
    path: "/Feriado/Novo",
    name: "feriado-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/FeriadoForm"))
  },
  {
    path: "/ChamadoPrioridade",
    name: "Chamado Prioridade",
    props: {
      name: "Chamado Prioridade",
      table: "ChamadoPrioridade",
      fields: [
        { name: "denominacao", description: "Denominação" },
        { name: "tipo", description: "Tipo" },
        { name: "toolTip", description: "ToolTip" },
        { name: "ordem", description: "Ordem" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ChamadoPrioridade/Detalhes/:id",
    name: "ChamadoPrioridade-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ChamadoPrioridadeForm"))
  },
  {
    path: "/ChamadoPrioridade/Novo",
    name: "ChamadoPrioridade-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ChamadoPrioridadeForm"))
  },
  {
    path: "/ProjetoTipo",
    name: "projeto-tipo",
    props: {
      name: "Tipo de Projeto",
      table: "ProjetoTipo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ProjetoTipo/Detalhes/:id",
    name: "projeto-tipo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ProjetoTipoForm"))
  },
  {
    path: "/ProjetoTipo/Novo",
    name: "projeto-tipo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ProjetoTipoForm"))
  },
  {
    path: "/ExpedienteTipo",
    name: "expediente-tipo",
    props: {
      name: "Tipo de Expediente",
      table: "ExpedienteTipo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ExpedienteTipo/Detalhes/:id",
    name: "expediente-tipo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ExpedienteTipoForm"))
  },
  {
    path: "/ExpedienteTipo/Novo",
    name: "expediente-tipo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ExpedienteTipoForm"))
  },
  {
    path: "/Tarefa",
    name: "tarefa",
    props: {
      name: "Tarefa",
      table: "Tarefa",
      include: "Projeto,TarefaStatus",
      filtrarAtivo: true,
      fields: [
        {
          name: "projeto",
          description: "Projeto",
          type: "descricao",
          sortName: "projeto.descricao"
        },
        { name: "denominacao", description: "Denominação", type: "nome" },
        {
          name: "tarefaStatus",
          description: "Status",
          type: "denominacao",
          sortName: "tarefaStatus.denominacao"
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Tarefa/Detalhes/:id",
    name: "tarefa-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/TarefaForm"))
  },
  {
    path: "/Tarefa/Edicao/:id",
    name: "tarefa-edicao",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/TarefaForm"))
  },
  {
    path: "/Tarefa/Resumo/:id",
    name: "tarefa-detalhe",
    component: () => lazyLoadView(import("@views/TarefaDetalhe"))
  },
  {
    path: "/Tarefa/Novo/:clienteId/:projetoId",
    name: "tarefa-Novo",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/TarefaForm"))
  },
  {
    path: "/Tarefa/Novo",
    name: "tarefa-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/TarefaForm"))
  },
  {
    path: "/Tarefa/Copiar/:id",
    name: "tarefa-copia",
    props: { editable: false, copy: true },
    component: () => lazyLoadView(import("@views/TarefaForm"))
  },
  {
    path: "/TarefaStatus",
    name: "tarefa-status",
    props: {
      name: "Status da Tarefa",
      table: "TarefaStatus",
      fields: [{ name: "denominacao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/TarefaStatus/Detalhes/:id",
    name: "tarefa-status-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/TarefaStatusForm"))
  },
  {
    path: "/TarefaStatus/Novo",
    name: "tarefa-status-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/TarefaStatusForm"))
  },
  {
    path: "/TarefaPrioridade",
    name: "tarefa-prioridade",
    props: {
      name: "Prioridade da Tarefa",
      table: "TarefaPrioridade",
      fields: [{ name: "denominacao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/TarefaPrioridade/Detalhes/:id",
    name: "tarefa-prioridade-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/TarefaPrioridadeForm"))
  },
  {
    path: "/TarefaPrioridade/Novo",
    name: "tarefa-prioridade-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/TarefaPrioridadeForm"))
  },
  {
    path: "/ExpedienteLocal",
    name: "expediente-local",
    props: {
      name: "Local do Expediente",
      table: "ExpedienteLocal",
      fields: [{ name: "denominacao", description: "Denominação" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ExpedienteLocal/Detalhes/:id",
    name: "expediente-local-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ExpedienteLocalForm"))
  },
  {
    path: "/ExpedienteLocal/Novo",
    name: "expediente-local-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ExpedienteLocalForm"))
  },
  {
    path: "/Equipe",
    name: "equipe-local",
    props: {
      name: "Equipe",
      table: "Equipe",
      fields: [{ name: "denominacao", description: "Denominação" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Equipe/Detalhes/:id",
    name: "equipe-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/EquipeForm"))
  },
  {
    path: "/Equipe/Novo",
    name: "equipe-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/EquipeForm"))
  },
  {
    path: "/Expediente/Novo",
    name: "expediente-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ExpedienteForm"))
  },
  {
    path: "/Expediente/Detalhes/:id",
    name: "expediente-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ExpedienteForm"))
  },
  {
    path: "/Expediente/Copiar/:id",
    name: "expediente-copia",
    props: { editable: false, copy: true },
    component: () => lazyLoadView(import("@views/ExpedienteForm"))
  },
  {
    path: "/ContratoDespesaTipo",
    name: "contrato-despesa-tipo",
    props: {
      name: "Tipo de Despesa de Contrato",
      table: "ContratoDespesaTipo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ContratoDespesaTipo/Detalhes/:id",
    name: "contrato-despesa-tipo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ContratoDespesaTipoForm"))
  },
  {
    path: "/ContratoDespesaTipo/Novo",
    name: "contrato-despesa-tipo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ContratoDespesaTipoForm"))
  },
  {
    path: "/ContratoTipo",
    name: "contrato-tipo",
    props: {
      name: "Tipo de Contrato",
      table: "ContratoTipo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ContratoTipo/Detalhes/:id",
    name: "contrato-tipo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ContratoTipoForm"))
  },
  {
    path: "/ContratoTipo/Novo",
    name: "contrato-tipo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ContratoTipoForm"))
  },
  {
    path: "/Contrato",
    name: "contrato",
    props: {
      name: "Contrato",
      table: "Contrato",
      include: "ContratoTipo,Cliente,TabelaCalculo",
      filtrarAtivo: true,
      fields: [
        {
          name: "descricao",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        {
          name: "contratoTipo",
          description: "Tipo do Contrato",
          type: "descricao",
          sortable: false
        },
        { name: "cliente", description: "Cliente", type: "nome" },
        { name: "dataInicio", description: "Data de início", type: "date" },
        { name: "dataFim", description: "Data de término", type: "date" },
        {
          name: "CH",
          description: "CH (horas)",
          type: "number"
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Contrato/Detalhes/:id",
    name: "contrato-detalhes",
    props: { editable: false, clientesInativo: false, teste: "sim"},
    component: () => lazyLoadView(import("@views/ContratoForm"))
  },
  {
    path: "/Contrato/Novo",
    name: "contrato-novo",
    props: { editable: true, clientesInativo: true},
    component: () => lazyLoadView(import("@views/ContratoForm"))
  },
  {
    path: "/ContratoRenovacao",
    name: "contrato-renovacao",
    props: {
      name: "Contrato Renovação",
      table: "ContratoRenovacao",
      include: "Contrato",
      fields: [
        {
          name: "contrato",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        { name: "dataInicio", description: "Data de início", type: "date" },
        { name: "dataFim", description: "Data de término", type: "date" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ContratoRenovacao/Detalhes/:id",
    name: "contrato-renovacao-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ContratoRenovacaoForm"))
  },
  {
    path: "/ContratoRenovacao/Novo",
    name: "contrato-renovacao-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ContratoRenovacaoForm"))
  },
  {
    path: "/Fatura",
    name: "fatura",
    props: {
      name: "Fatura",
      table: "Fatura",
      include: "Contrato",
      fields: [
        { name: "anoMes", description: "AnoMes" },
        { name: "data", description: "Data", type: "date" },
        {
          name: "contrato",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        { name: "nfSe", description: "NFSe" },
        {
          name: "dataVencimento",
          description: "Data de Vencimento",
          type: "date"
        },
        {
          name: "dataPagamento",
          description: "Data de Pagamento",
          type: "date"
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Fatura/Detalhes/:id",
    name: "fatura-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/FaturaForm"))
  },
  {
    path: "/Fatura/Novo",
    name: "fatura-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/FaturaForm"))
  },
  {
    path: "/ContratoAditivo",
    name: "contratoAditivo",
    props: {
      name: "Contrato Aditivo",
      table: "ContratoAditivo",
      include: "Contrato",
      fields: [
        {
          name: "contrato",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        {
          name: "data",
          description: "Data do Aditivo",
          type: "date"
        },
        {
          name: "cargaHoraria",
          description: "Carga horária (horas)",
          type: "number"
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ContratoAditivo/Detalhes/:id",
    name: "contrato-aditivo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ContratoAditivoForm"))
  },
  {
    path: "/ContratoAditivo/Novo",
    name: "contrato-aditivo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ContratoAditivoForm"))
  },
  {
    path: "/ContratoDespesa",
    name: "contrato-despesa",
    props: {
      name: "Contrato Despesa",
      table: "ContratoDespesa",
      include: "Contrato,ContratoDespesaTipo",
      fields: [
        {
          name: "contrato",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        {
          name: "contratoDespesaTipo",
          description: "Tipo Despesa",
          type: "descricao",
          sortable: false
        },
        { name: "descricao", description: "Descrição" },
        { name: "valor", description: "Valor", type: "money" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ContratoDespesa/Detalhes/:id",
    name: "contrato-despesa-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ContratoDespesaForm"))
  },
  {
    path: "/ContratoDespesa/Novo",
    name: "contrato-despesa-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ContratoDespesaForm"))
  },
  {
    path: "/Parametro",
    name: "parametro",
    props: {
      name: "Parâmetro",
      table: "Parametro",
      fields: [
        { name: "nome", description: "Nome" },
        { name: "valor", description: "Valor Textual" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Parametro/Detalhes/:id",
    name: "parametro-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ParametroForm"))
  },
  {
    path: "/Parametro/Novo",
    name: "parametro-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ParametroForm"))
  },
  {
    path: "/RelatorioTipo",
    name: "relatorio-tipo",
    props: {
      name: "Tipo de Relatório",
      table: "RelatorioTipo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/RelatorioTipo/Detalhes/:id",
    name: "relatorio-tipo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/RelatorioTipoForm"))
  },
  {
    path: "/RelatorioTipo/Novo",
    name: "relatorio-tipo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/RelatorioTipoForm"))
  },
  {
    path: "/AlterarSenha",
    name: "alterar-senha",
    component: () => lazyLoadView(import("@views/AlterarSenhaForm"))
  },
  {
    path: "/Usuario",
    name: "usuario",
    props: {
      name: "Usuário",
      table: "Usuario",
      fields: [
        { name: "nome", description: "Nome" },
        { name: "email", description: "E-mail" },
        { name: "ativo", description: "Ativo", type: "boolean" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Usuario/Detalhes/:id",
    name: "usuario-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/UsuarioForm"))
  },
  {
    path: "/Usuario/Novo",
    name: "usuario-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/UsuarioForm"))
  },
  {
    path: "/Agenda",
    name: "agenda",
    props: {
      name: "Agenda",
      table: "Agenda",
      include: "Projeto",
      fields: [
        {
          name: "projeto",
          description: "Projeto",
          type: "descricao",
          sortable: false
        },
        { name: "data", description: "Data", type: "date" },
        { name: "horaInicio", description: "Hora Início" },
        { name: "horaFim", description: "Hora Fim" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Agenda/Detalhes/:id",
    name: "agenda-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/AgendaForm"))
  },
  {
    path: "/Agenda/Novo",
    name: "agenda-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/AgendaForm"))
  },
  {
    path: "/Consultor",
    name: "consultor",
    props: {
      name: "Consultor",
      table: "Consultor",
      filtrarAtivo: true,
      fields: [
        { name: "nome", description: "Nome" },
        { name: "telefone", description: "Telefone" },
        { name: "email", description: "E-mail" }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Consultor/Detalhes/:id",
    name: "consultor-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ConsultorForm"))
  },
  {
    path: "/Consultor/Novo",
    name: "consultor-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ConsultorForm"))
  },
  {
    path: "/Cliente",
    name: "cliente",
    props: {
      name: "Cliente",
      filtrarAtivo: true,
      table: "Cliente",
      fields: [{ name: "nome", description: "Nome" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Cliente/Detalhes/:id",
    name: "cliente-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ClienteForm"))
  },
  {
    path: "/Cliente/Novo",
    name: "cliente-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ClienteForm"))
  },
  {
    path: "/ProjetoExtrato",
    name: "projeto-extrato",
    props: {
      name: "Projeto Extrato",
      table: "ProjetoExtrato",
      include: "Projeto",
      fields: [
        { name: "anoMes", description: "Ano Mês" },
        {
          name: "projeto",
          description: "Projeto",
          type: "descricao",
          sortable: false
        },
        {
          name: "projeto",
          description: "Cliente",
          type: "contrato.cliente.nome",
          sortable: false
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ProjetoExtrato/Detalhes/:id",
    name: "projeto-extrato-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ProjetoExtratoForm"))
  },
  {
    path: "/ProjetoExtrato/Novo",
    name: "projeto-extrato-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ProjetoExtratoForm"))
  },
  {
    path: "/TabelaCalculo",
    name: "tabela-calculo",
    props: {
      name: "Tabela de Cálculo",
      table: "TabelaCalculo",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/TabelaCalculo/Detalhes/:id",
    name: "tabela-calculo-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/TabelaCalculoForm"))
  },
  {
    path: "/TabelaCalculo/Novo",
    name: "tabela-calculo-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/TabelaCalculoForm"))
  },
  {
    path: "/ChamadoFluxoTransicao",
    name: "chamado-fluxo-transicao",
    props: {
      name: "Chamado Fluxo Transicao",
      table: "ChamadoFluxoTransicao",
      include: "EtapaFluxoDestino,EtapaFluxoOrigem",
      fields: [
        { name: "nomeAcao", description: "Nome da ação" },
        {
          name: "etapaFluxoOrigem",
          description: "Etapa origem",
          type: "denominacao",
          sortable: false
        },
        {
          name: "etapaFluxoDestino",
          description: "Etapa destino",
          type: "denominacao",
          sortable: false
        }
      ]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/ChamadoFluxoTransicao/Detalhes/:id",
    name: "chamado-fluxo-transicao-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ChamadoFluxoTransicao"))
  },
  {
    path: "/ChamadoFluxoTransicao/Novo",
    name: "chamado-fluxo-transicao-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ChamadoFluxoTransicao"))
  },
  {
    path: "/Perfil",
    name: "perfil",
    props: {
      name: "Perfil",
      table: "Perfil",
      fields: [{ name: "descricao", description: "Descrição" }]
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Perfil/Detalhes/:id",
    name: "perfil-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/PerfilForm"))
  },
  {
    path: "/Perfil/Novo",
    name: "Perfil-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/PerfilForm"))
  },
  {
    path: "/DataFechamento",
    name: "Data-Fechamento",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/DataFechamento"))
  },
  {
    path: "/Projeto",
    name: "projeto",
    props: {      
      name: "Projeto",
      table: "Projeto",
      include: "TabelaCalculo,ProjetoTipo",      
      filtrarAtivo: true,
      fields: [
        {
          name: "projetoTipo",
          description: "Tipo do projeto",
          type: "descricao",
          sortable: false
        },
        {
          name: "contrato",
          description: "Contrato",
          type: "descricao",
          sortable: false
        },
        { name: "descricao", description: "Descrição" }
      ]
      
    },
    component: () => lazyLoadView(import("@views/CrudTable"))
  },
  {
    path: "/Projeto/Detalhes/:id",
    name: "projeto-detalhes",
    props: { editable: false },
    component: () => lazyLoadView(import("@views/ProjetoForm"))
  },
  {
    path: "/Projeto/Novo",
    name: "projeto-novo",
    props: { editable: true },
    component: () => lazyLoadView(import("@views/ProjetoForm"))
  },
  {
    path: "/Tarefas",
    name: "tarefas",
    component: () => lazyLoadView(import("@views/Tarefas"))
  },
  {
    path: "/403",
    name: "403",
    component: require("@views/_403").default,
    props: true
  },
  {
    path: "/404",
    name: "404",
    component: require("@views/_404").default,
    props: true
  },
  {
    path: "*",
    redirect: "404"
  }
];

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require("@views/_loading").default,
    delay: 100,
    error: require("@views/_timeout").default,
    timeout: 10000
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children);
    }
  });
}
